module.exports = __webpack_public_path__ + "static/img/s47.57486a25.png";